import { Component, Inject } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogClose,
  MatDialogContent,
  MatDialogActions,
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';

import { ButtonComponent } from '../../../shared/components/button/button.component';
import { TranslateModule } from '@ngx-translate/core';

export interface ShowInfoItem {
  infoData: string;
  tipData?: string;
  closeButton?: string;
  chipData?: {
    label: string;
    link: string;
    icon?: string;
  };
}

@Component({
  selector: 'qa-show-info-dialog',
  templateUrl: './show-info-dialog.component.html',
  styleUrls: ['./show-info-dialog.component.scss'],
  imports: [
    MatDialogTitle,
    MatIcon,
    MatDialogClose,
    CdkScrollable,
    MatDialogContent,
    MatDialogActions,
    ButtonComponent,
    TranslateModule,
  ],
})
export class ShowInfoDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ShowInfoItem,
    public dialogRef: MatDialogRef<ShowInfoDialogComponent>
  ) {}

  openLink() {
    window.open(this.data.chipData.link, '_blank');
  }
}
